<div class="filter-wrapper">
  <kendo-switch [(ngModel)]="selectedValue" [onLabel]="onLabel" [offLabel]="offLabel"> </kendo-switch>

  <button class="k-button k-button-icon" title="Clear" type="button" *ngIf="selectedValue !== null" (click)="clear()">
    <span class="k-icon k-i-filter-clear"></span>
  </button>
</div>
